var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminMgt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/user-edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99935 8.49999C5.88602 8.49999 4.16602 6.77999 4.16602 4.66666C4.16602 2.55333 5.88602 0.833328 7.99935 0.833328C10.1127 0.833328 11.8327 2.55333 11.8327 4.66666C11.8327 6.77999 10.1127 8.49999 7.99935 8.49999ZM7.99935 1.83333C6.43935 1.83333 5.16602 3.10666 5.16602 4.66666C5.16602 6.22666 6.43935 7.49999 7.99935 7.49999C9.55935 7.49999 10.8327 6.22666 10.8327 4.66666C10.8327 3.10666 9.55935 1.83333 7.99935 1.83333Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.547 15.1667C10.2937 15.1667 10.0537 15.0733 9.88036 14.9C9.6737 14.6933 9.58036 14.3933 9.62703 14.08L9.7537 13.18C9.78703 12.9467 9.92704 12.6733 10.0937 12.5L12.4537 10.14C13.4004 9.19335 14.2337 9.73335 14.6404 10.14C14.987 10.4867 15.167 10.86 15.167 11.2333C15.167 11.6133 14.9937 11.9667 14.6404 12.32L12.2803 14.68C12.1137 14.8467 11.8337 14.9867 11.6004 15.02L10.7004 15.1467C10.647 15.16 10.6004 15.1667 10.547 15.1667ZM13.5404 10.6133C13.4204 10.6133 13.3137 10.6934 13.1604 10.8467L10.8004 13.2067C10.7804 13.2267 10.747 13.2933 10.747 13.32L10.627 14.1533L11.4604 14.0333C11.487 14.0267 11.5537 13.9934 11.5737 13.9734L13.9337 11.6133C14.0404 11.5067 14.167 11.3533 14.167 11.2333C14.167 11.1333 14.087 10.9934 13.9337 10.8467C13.7737 10.6867 13.6537 10.6133 13.5404 10.6133Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.9471 12.8133C13.9004 12.8133 13.8537 12.8067 13.8137 12.7933C12.9337 12.5467 12.2337 11.8467 11.9871 10.9667C11.9137 10.7 12.0671 10.4267 12.3337 10.3533C12.6004 10.28 12.8737 10.4333 12.9471 10.7C13.1004 11.2467 13.5337 11.68 14.0804 11.8333C14.3471 11.9067 14.5004 12.1866 14.4271 12.4466C14.3671 12.6666 14.1671 12.8133 13.9471 12.8133Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.27344 15.1667C2.0001 15.1667 1.77344 14.94 1.77344 14.6667C1.77344 11.82 4.56679 9.5 8.00012 9.5C8.72679 9.5 9.44678 9.60668 10.1201 9.80668C10.3868 9.88668 10.5335 10.1667 10.4535 10.4267C10.3735 10.6933 10.0935 10.84 9.83346 10.76C9.24679 10.5867 8.63346 10.4933 8.00012 10.4933C5.12012 10.4933 2.77344 12.36 2.77344 14.66C2.77344 14.94 2.54677 15.1667 2.27344 15.1667Z",
    fill: "#292D32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminMgt);
export default __webpack_public_path__ + "static/media/admin_mgt.f261dc249f1509d40a12a8ebf91e6d7c.svg";
export { ForwardRef as ReactComponent };